<div class="row">
  <div class="col">
    <nav class="scrolled navbar navbar-expand-lg navbar-dark">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img style="width: 140px" src="assets/toplog.png" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- Push items to the right -->
          <ul class="navbar-nav ms-auto p-2" style="color: black">
            <li class="nav-item"  >
              <a class="nav-link" style="color: white" href="#"
                ><i class="fas fa-home" aria-hidden="true"></i
              ></a>
            </li>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="serviceDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style="cursor: pointer; color: white"
              >
                Service
                <i
                  style="position: relative; bottom: 3px"
                  class="fa fa-sort-desc"
                  aria-hidden="true"
                ></i>
              </a>
              <ul class="dropdown-menu" aria-labelledby="serviceDropdown">
                <li>
                  <a class="dropdown-item"
                  style="color: white;cursor: pointer;" 
                   (click)="navigateWithTab('id')"
                    >KYC Verifications</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" 
                  style="color: white;cursor: pointer;"
                  (click)="navigateWithTab('other')"
                    >Document Signer</a
                  >
                </li>
              </ul>
            </li>
&nbsp;&nbsp;&nbsp;&nbsp;
            <!-- <li class="nav-item">
              <a
                class="nav-link"
                style="color: white"
                href="/aboutus"
                >Pricing</a
              >
            </li>
&nbsp;&nbsp;&nbsp;&nbsp; -->
            <li class="nav-item">
              <a
                class="nav-link"
                style="color: white"
                href="/aboutus"
                >About Us</a
              >
            </li>
&nbsp;&nbsp;&nbsp;&nbsp;
            <li class="nav-item">
              <a
                class="nav-link"
                style="color: white"
                href="/contactus"
                >Contact Us</a
              >
            </li>
&nbsp;&nbsp;&nbsp;&nbsp;
            <li class="nav-item">
              <a
                class="nav-link signup-btn"
                style="cursor: pointer"
                (click)="openLink('/signUp')"
                >Sign Up</a
              >
            </li>
            <!-- <li class="nav-item">
                <img style="width: 28px;height: 23px;margin-top: 10px;" src="assets/flag image.jpg">
              </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>

<router-outlet></router-outlet>

<div class="row">
  <div class="col">
    <!-- Footer -->
    <footer
      class="text-center text-lg-start text-white"
      style="background-color: #5170ff"
    >
      <!-- Section: Social media -->
      <!-- <section class="d-flex justify-content-between p-4" style="background-color: #6ab187"> -->
      <!-- Left -->
      <!-- <div class="me-5">
            <span>Get connected with us on social networks:</span>
          </div> -->
      <!-- Left -->

      <!-- Right -->
      <!-- <div>
  
            <a href="" class="text-white me-5">
              <i class="fab fa-instagram"></i>
            </a> -->

      <!-- </div> -->
      <!-- Right -->
      <!-- </section> -->
      <!-- Section: Social media -->

      <section class="p-4">
        <div class="text-center text-md-start mt-5">
          <div class="row">
            <div class="col-md-4 text-start">
              <!-- Content -->
              <img
                src="../../assets/toplog.png"
                style="width: 140px"
                alt=""
                srcset=""
              />
              <br>
              <br>
              <!-- <h6  class="text-uppercase fw-bold">FA CHECK </h6> -->

              <p style="text-align: justify; text-justify: inter-word">
                Build trust and prevent fraud with FA Check’s Business
                Verification Service. Instantly verify business details using
                secure, real-time APIs
              </p>
            </div>

          

            <div class="col-md-2 text-start ">
              <h6 class="text-uppercase fw-bold"  style="border-left: 3px solid white;padding: 8px;" >Quick Links</h6>

              <p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;
                <a
                
                  (click)="openLink('/home')"
                  style="cursor: pointer"
                  class="text-white"
                  >Home</a
                >
              </p>
              <p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

                <a
                  (click)="openLink('/aboutus')"
                  style="cursor: pointer"
                  class="text-white"
                  >About Us</a
                >
              </p>
              <p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

                <a
                  (click)="openLink('/contactus')"
                  style="cursor: pointer"
                  class="text-white"
                  >Contact Us</a
                >
              </p>


              
            </div>

            <div class="col-md-2 text-start">
              <h6 class="text-uppercase fw-bold" style="border-left: 3px solid white;padding: 8px;" >Policy links</h6>

<p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

              <a
                (click)="openLink('/disclaimer')"
                style="cursor: pointer"
                >Disclaimer</a
              >
              </p>
              <p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

              <a
                (click)="openLink('/privacypolicy')"
                style="cursor: pointer"
                >Privacy Policy</a
              >
              </p>
              <p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

              <a
                (click)="openLink('/termscondition')"
                style="cursor: pointer"
                >Terms & Condition</a
              >
              </p>
<p>
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>&nbsp;

              <a
                (click)="openLink('/refundpolicy')"
                style="cursor: pointer"
                >Refund Policy</a
              >
           </p>   
              <!-- Links -->
            </div>

            <div class="col-md-4 text-start">
              <h6 class="text-uppercase fw-bold" style="border-left: 3px solid white;padding: 8px;" >Contact</h6>

              <p>support@facheck.in &nbsp;<i class="fas fa-envelope mr"></i></p>

              <p class="text-start">
                Registered Head Office <i class="fas fa-home"></i> <br />New 9,
                Old # 11, Ground Floor, Palayakaran Street, Kalaimagal Nagar,
                Ekkaduthangal, Chennai
              </p>
              <!-- Links -->
            </div>
          </div>
          <!-- Grid row -->
        </div>
      </section>
      <br />
      <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
     <b>FACHECK</b> product of Baabuji Venturess Private Limited Copyright © 2024-2026. All rights reserve.
        
        <!-- <a class="text-white" href="#">facheck.in | All Rights Reserved </a> -->
      </div>
    </footer>
    <!-- Footer -->
  </div>
</div>


 <div id="welcomeDialog" class="dialog-overlay">
  <div class="dialog-box ">
    <!-- Close button -->
    <button id="closeDialogX" class="dialog-close">&times;</button>

    <!-- Image at top -->
    <div class="dialog-image">
      <img src="../../assets/Image/pop up image (1).png" alt="FA Check Logo">
    </div>
<br>
    <!-- Content -->
    <h2>Get Started with FA Check</h2>
    <p class="p-2" >
      Enable smart verification to protect your users and prevent fraud in real time.
    </p>
    <button  routerLink="/contactus" id="closeDialog" class="dialog-btn">Contact Us</button>
    <br>
    <br>
  </div>
</div>

